export default __webpack_public_path__ + "static/media/04__o_preview_3.a44d63f0.jpg";